module.exports = __webpack_public_path__ + "img/nt55-03-80-1.prt.3c6fff58.jpg";